export function SearchEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="139"
        viewBox="0 0 200 139"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M114.7 105.3L140.7 131.3C139.375 129.878 138.654 127.998 138.688 126.055C138.723 124.112 139.51 122.258 140.884 120.884C142.258 119.51 144.112 118.723 146.055 118.688C147.998 118.654 149.878 119.375 151.3 120.7L125.3 94.7002C126.625 96.1219 127.346 98.0024 127.312 99.9454C127.277 101.888 126.49 103.742 125.116 105.116C123.742 106.491 121.888 107.278 119.945 107.312C118.002 107.346 116.122 106.625 114.7 105.3Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M90 112C113.196 112 132 93.196 132 70C132 46.804 113.196 28 90 28C66.804 28 48 46.804 48 70C48 93.196 66.804 112 90 112Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M74 66C78 70.6667 82 70.6667 86 66"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M94 66C98 70.6667 102 70.6667 106 66"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M82 80C87.3333 84 92.6667 84 98 80"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M68.5 78.5C70.1569 78.5 71.5 77.1569 71.5 75.5C71.5 73.8431 70.1569 72.5 68.5 72.5C66.8431 72.5 65.5 73.8431 65.5 75.5C65.5 77.1569 66.8431 78.5 68.5 78.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M108.5 78.5C110.157 78.5 111.5 77.1569 111.5 75.5C111.5 73.8431 110.157 72.5 108.5 72.5C106.843 72.5 105.5 73.8431 105.5 75.5C105.5 77.1569 106.843 78.5 108.5 78.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M145 19C136.333 21 130 25.6667 126 33"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M150 14.9998C156.552 11.9876 162.165 14.9016 162.214 20.9842C155.975 22.0209 151.35 19.2634 150 14.9998Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M150 14.9997C148.963 8.76067 153.696 4.44797 159.622 5.38657C158.684 11.3127 155.095 14.7942 150 14.9997Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M28 108L30 113L35 115L30 117L28 122L26 117L21 115L26 113L28 108Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M152 132.6C153.436 132.6 154.6 131.436 154.6 130C154.6 128.564 153.436 127.4 152 127.4C150.564 127.4 149.4 128.564 149.4 130C149.4 131.436 150.564 132.6 152 132.6Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
